export default __webpack_public_path__ + "static/media/binance.d8c61230.svg";